import React from 'react';
import logo from './logo.svg';
import './App.css';
import {
  result,
  results,
  message,
  spawn,
  monitor,
  unmonitor,
  dryrun,
} from "@permaweb/aoconnect";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Game from './Components/Game';
import Test from './Components/Test';
import './index.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">

      <Game />
      
      {/* <Router>
          <Routes>
            <Route path="/" element={<Game />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Test" element={<Test />} />
          </Routes>
        </Router> */}
        
      </header>
    </div>
  );
}

export default App;
